// extracted by mini-css-extract-plugin
module.exports = {"template":"Templates-module--template--2F1WM","selected":"Templates-module--selected--1TNO2"};